import { smoothScrollHandler } from '@pc/components/SmoothScrollHandler'

const clickEvent = () => {
  const elements = document.querySelectorAll('[class*="js-ev-"]')
  if (elements === null) return

  elements.forEach((el) => {
    el.addEventListener('click', (e) => {
      const target = e.currentTarget as HTMLAnchorElement
      const classNames = target.classList
      classNames.forEach((className: string) => {
        if (className.includes('js-ev-')) {
          window.gtag('event', 'click', {
            event_label: 'lpCompany',
            event_element: className.replace('js-ev-', ''),
            event_value: target.href
          })
        }
      })
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  // スムーズスクロール
  smoothScrollHandler('js-scroll')

  // イベントトラッキング
  clickEvent()
})
